export const title = {
  es: "Planificación y uso de la cuenta",
  en: "Account planning and usage",
};

export const labels = {
  es: {
    beneficiarySetup: {
      name: "Nombre del beneficiario",
      percentage: "Porcentaje asignado",
    },
    beneficiary: {
      name: "Nombre completo del beneficiario",
      percentage: "Porcentaje asignado",
      gender: "Género",
      birthDate: "Fecha de Nacimiento",
      phone: "Número de teléfono móvil del beneficiario",
      taxIdType: "Tipo de identificación fiscal (CUIT / CUIL / TAX ID)",
      email: "Mail del beneficiario",
      taxIdNumber: "Número de identificación fiscal",
      socialSecurityNumber: "Número de Seguridad Social o Tax ID",
      relationship: "Relación con el beneficiario",
      country: "País de residencia del beneficiario",
      fullAddress: "Domicilio del beneficiario",
      city: "Ciudad",
      zipCode: "Código postal",
      state: "Estado / Provincia",
      floor: "Piso",
      apartment: "Departamento",
      preconfirmationName: "Nombre del beneficiario",
      documentFront: "Frente",
      documentBack: "Dorso"
    },
    accountObjective: "¿Cuál es el objetivo de abrir la cuenta?",
    originOfFunds: "¿Cuál es el origen inicial de los fondos?",
    otherOriginOfFunds: "Otros",
    fundingDate: "¿En cuántos días planeás fondear la cuenta?",
    initialTransferAmount: "Monto aproximado de la transferencia inicial (USD)",
    fundingSource: "¿Desde dónde se transferirán los fondos?",
    fundingSourceBankName: "Nombre del banco",
    fundingSourceAccountHolder: "Nombre del titular",
    timeHorizon: "Indique su horizonte de inversión",
    riskProfile: "¿Qué perfil de riesgo anticipás usar para esta cuenta?",
    regularWithdrawals: {
      bool: "¿Vas a realizar retiros regulares en esta cuenta?",
      reason: "¿Cuál sería el motivo de estos retiros regulares?",
      otherReason: "Otros",
      frequency: "¿Con qué frecuencia se realizarán estos retiros?",
      otherFrequency: "Otros",
    },
    thirdPartyTransfers: {
      bool: "¿Recibirá o enviará transferencias a/desde terceros?",
      frequency: "¿Con qué frecuencia se realizarán estas transferencias?",
      otherReason: "Otros",
      reason: "¿Cuál sería el motivo de estas transferencias?",
      otherFrequency: "Otros",
    },
    tradeOptions: {
      label: "Objetivo de inversión",
      bool: "¿Te interesaría operar Opciones?",
    },
    tradeMargins: { bool: "¿Te interesaría operar Margins?" },
    beneficiariesBool:
      "¿Te interesa asignar beneficiarios en caso de fallecimiento?",
  },
  en: {
    beneficiarySetup: {
      name: "Beneficiary name",
      percentage: "Assigned percentage",
    },
    beneficiary: {
      name: "Full name of the beneficiary",
      percentage: "Assigned percentage",
      gender: "Gender",
      birthDate: "Date of Birth",
      phone: "Mobile phone number of the beneficiary",
      email: "Email of the beneficiary",
      taxIdType: "Tax identification type (CUIT / CUIL / TAX ID)",
      taxIdNumber: "Tax identification number",
      socialSecurityNumber: "Social Security Number or Tax ID",
      relationship: "Relationship with the beneficiary",
      country: "Country of residence of the beneficiary",
      fullAddress: "Address of the beneficiary",
      city: "City",
      zipCode: "Postal code",
      state: "State / Province",
      floor: "Floor",
      apartment: "Department",
      preconfirmationName: "Beneficiary name",
      documentFront: "Front",
      documentBack: "Back",
    },
    accountObjective: "What is the purpose of opening the account?",
    originOfFunds: "What is the initial source of the funds?",
    otherOriginOfFunds: "Other",
    fundingDate: "In how many days do you plan on funding the account?",
    initialTransferAmount: "Approximate amount of the initial transfer (USD)",
    fundingSource: "Where will the funds be transferred from?",
    fundingSourceBankName: "Bank name",
    fundingSourceAccountHolder: "Account holder",
    timeHorizon: "Indicate your time horizon",
    riskProfile: "What risk profile do you anticipate using for this account?",
    regularWithdrawals: {
      bool: "Will you be making regular withdrawals from this account?",
      reason: "What would be the reason for these regular withdrawals?",
      otherReason: "Other",
      frequency: "How often will these withdrawals occur?",
      otherFrequency: "Other",
    },
    thirdPartyTransfers: {
      bool: "Will you receive or send transfers to/from third parties?",
      reason: "What would be the reason for these third party transfers?",
      otherReason: "Other",
      frequency: "How often will these transfers occur?",
      otherFrequency: "Other",
    },
    tradeOptions: {
      label: "Investment objective",
      bool: "Would you be interested in trading Options?",
    },
    tradeMargins: { bool: "Would you be interested in trading Margins?" },
    beneficiariesBool:
      "Are you interested in assigning beneficiaries in case of death?",
  },
};

export const preconfirmationLabels = {
  es: {
    beneficiaryPhone: "Teléfono móvil del beneficiario",
    fundingSource: "¿Desde dónde se transferirán los fondos?",
  },
  en: {
    beneficiaryPhone: "Beneficiary's mobile phone",
    fundingSource: "Where will the funds be transferred from?",
  },
};

export const placeholders = {
  es: {
    beneficiarySetup: {
      name: "Ej. John Doe",
      percentage: "Ej. 100%",
    },
    beneficiary: {
      gender: "Seleccioná una opción",
      birthDate: "DD/MM/AAAA",
      email: "Ej. direccion@mail.com",
      taxIdType: "Seleccioná una opción",
      taxIdNumber: "XX-XXXXXXXX-X",
      socialSecurityNumber: "XXX-XX-XXXX",
      relationship: "Ej. Padre",
      country: "Seleccioná una opción",
      fullAddress: "Calle y número",
      city: "Ej. CABA",
      zipCode: "Ej. 1426",
      state: "Ej. Buenos Aires",
      floor: "Ej. 1",
      apartment: "Ej. A",
    },
    accountObjective: "Seleccioná una opción",
    otherOriginOfFunds: "Indicar otros orígenes",
    fundingDate: "Ej. 10",
    initialTransferAmount: "U$D",
    fundingSourceBankName: "Ej. Banco Santander",
    fundingSourceAccountHolder: "Ej. Juan Carlos",
    timeHorizon: "Seleccionar opción",
    riskProfile: "Seleccionar opción",
    regularWithdrawals: {
      bool: "",
      reason: "Selecciona una opción",
      otherReason: "Explique brevemente",
      frequency: "Selecciona una opción",
      otherFrequency: "Explique brevemente",
    },
    thirdPartyTransfers: {
      bool: "",
      reason: "Selecciona una opción",
      otherReason: "Explique brevemente",
      frequency: "Selecciona una opción",
      otherFrequency: "Explique brevemente",
    },
    tradeOptions: { bool: "" },
    tradeMargins: { bool: "" },
    beneficiariesBool: "",
    addBeneficiaryButton: "",
  },
  en: {
    beneficiarySetup: {
      name: "E.g. John Doe",
      percentage: "E.g. 100%",
    },
    beneficiary: {
      gender: "Select an option",
      birthDate: "DD/MM/YYYY",
      email: "E.g. address@mail.com",
      taxIdType: "Select an option",
      taxIdNumber: "XX-XXXXXXXX-X",
      socialSecurityNumber: "XXX-XX-XXXX",
      relationship: "E.g. Family",
      country: "Select an option",
      fullAddress: "Street and number",
      city: "E.g. CABA",
      zipCode: "E.g. 1426",
      state: "E.g. Buenos Aires",
      floor: "E.g. 1",
      apartment: "E.g. A",
    },
    accountObjective: "Select an option",
    otherOriginOfFunds: "Indicate other sources",
    fundingDate: "E.g. 10",
    initialTransferAmount: "U$D",
    fundingSourceBankName: "E.g. Santander Bank",
    fundingSourceAccountHolder: "E.g. Juan Carlos",
    timeHorizon: "Select option",
    riskProfile: "Select option",
    regularWithdrawals: {
      bool: "",
      reason: "Select an option",
      otherReason: "Please explain briefly",
      frequency: "Select an option",
      otherFrequency: "Please explain briefly",
    },
    thirdPartyTransfers: {
      bool: "",
      reason: "Select an option",
      otherReason: "Please explain briefly",
      frequency: "Select an option",
      otherFrequency: "Please explain briefly",
    },
    tradeOptions: { bool: "" },
    tradeMargins: { bool: "" },
    beneficiariesBool: "",
    addBeneficiaryButton: "",
  },
};

export const descriptions = {
  es: {
    originOfFunds:
      "Si está transfiriendo activos desde otra institución financiera, indique el origen de esas inversiones.",
    fundingSource: "Indicar nombre de banco y titular de la cuenta",
    tradeOptions: "Puede seleccionar más de una opción",
  },
  en: {
    originOfFunds:
      "If you are transferring assets from another financial institution, please indicate the source of those investments.",
    fundingSource: "Please indicate the bank name and account holder",
    tradeOptions: "You can select more than one option",
  },
};

export const texts = {
  es: {
    timeHorizonTooltip:
      "Período de tiempo en el que no espera realizar retiros relevantes",
    proofOfAddressTooltip:
      "Puede ser una factura de un servicio con la misma dirección que se ingresó anteriormente. El comprobante de domicilio no debe superar los 3 meses de antiguedad",
    beneficiary: "Beneficiario",
    section1: "Sección 1: Objetivo y fondos",
    section2: "Sección 2: Perfil de riesgo",
    section3: "Sección 3: Transferencias y retiros",
    section4: "Sección 4: Operaciones con Opciones y Margins",
    section5: "Sección 5: Beneficiarios",
    important: "Importante",
    beneficiariesInfo: "Las personas asignadas como beneficiarias no pueden ser cotitulares de la cuenta.",
    addBeneficiaryButton: "Agregar otro beneficiario",
    initialTransferAmountTooSmallMessage:
      "Debe ser menor al patrimimonio líquido ingresado anteriormente",
    documentImagesLabelTitle: "Cargá fotos del frente y dorso del Documento de Identidad del beneficiario.",
    documentImagesLabelBody: "Deben estar bien iluminadas y legibles, sin sombras ni reflejos.",
  },
  en: {
    timeHorizonTooltip:
      "Period you don't expect making meaningful withdrawals within",
    proofOfAddressTooltip:
      "Could be a receipt for a service issued to the same address you entered previously. The proof of adress cannot be older than 3 months.",
    beneficiary: "Beneficiary",
    section1: "Section 1: Purpose and funds",
    section2: "Section 2: Risk profile",
    section3: "Section 3: Transfers and withdrawals",
    section4: "Section 4: Options and Margin Operations",
    section5: "Section 5: Beneficiaries",
    important: "Important",
    beneficiariesInfo: "People designated as beneficiaries cannot be co-holders of the account.",
    addBeneficiaryButton: "Add another beneficiary",
    initialTransferAmountTooSmallMessage:
      "Has to be less than net worth previously stated",
    documentImagesLabelTitle: "Upload photos of the front and back of the beneficiary's ID.",
    documentImagesLabelBody: "They should be well-lit and legible, without shadows or reflections.",
  },
};

export const subStepNames = {
  es: {
    planning: "Planificación y uso de la cuenta",
    beneficiaries: "Designación de beneficiarios",
  },
  en: {
    planning: "Account planning and usage",
    beneficiaries: "Designation of beneficiaries",
  },
};
